module.exports = __webpack_public_path__ + "img/5-3.6b257993.png";